<template>
  <!-- 把hover事件绑定到外层容器，统一控制显示/隐藏 -->
  <div class="wechat-float" @mouseenter="showQrcode = true" @mouseleave="showQrcode = false">
    <!-- 微信图标按钮：移除蓝色背景 -->
    <div class="wechat-icon">
      <img src="@/assets/images/wechat-icon.png" alt="微信图标" style="width: 48px; height: 48px;" />
    </div>
    <!-- 二维码浮层：绝对定位到图标左侧，避免和图标触发区域重叠 -->
    <div class="wechat-qrcode-float" v-show="showQrcode">
      <img src="@/assets/images/wechat-qrcode.png" alt="微信二维码" style="width: 150px; height: 150px; object-fit: contain;" />
<!--      <p style="font-size: 12px; color: var(&#45;&#45;text-secondary); text-align: center; margin-top: 8px;">官方微信</p>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'WechatFloat',
  data() {
    return {
      showQrcode: false // 控制二维码显示/隐藏
    }
  }
}
</script>

<style scoped>
/* 浮窗容器：固定在右侧，垂直居中 */
.wechat-float {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999; /* 确保浮在最上层 */
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer; /* 统一鼠标样式 */
}

/* 微信图标按钮：移除蓝色背景，仅保留基础布局 */
.wechat-icon {
  width: 48px;
  height: 48px;
  /* 移除蓝色背景、圆角、阴影 */
  /* background-color: var(--primary-blue); */
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 2px 8px rgba(45, 75, 153, 0.3); */
  transition: var(--transition-base);
  /* 防止图标被浮层遮挡导致hover判定异常 */
  position: relative;
  z-index: 2;
}

/* 优化hover效果：无背景时加轻微缩放+浅阴影（可选，可删除） */
.wechat-icon:hover {
  transform: scale(1.05);
  /* 可选：加个浅阴影提升视觉反馈，不需要可删除 */
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  /* 如需完全无hover效果，删除上面两行，只保留 transform: none; */
  /* transform: none; */
}

/* 二维码浮层：绝对定位到图标左侧，避免和图标触发区域重叠 */
.wechat-qrcode-float {
  position: absolute;
  right: 58px; /* 图标宽度+间距，确保浮层在图标左侧 */
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  background-color: white;
  border-radius: var(--radius-md);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  /* 增加过渡效果，减少视觉闪动 */
  transition: all 0.2s ease;
  /* 浮层层级低于图标，避免遮挡导致hover判定异常 */
  z-index: 1;
}
</style>